import '@/tools/table2CSV';
const modules = vueTools.importModule('modules', 'tools').default;
import XLSX from 'sheetjs-style';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

//import ExcelJS from 'exceljs';

class FrontTools {

    value (v){
        return v? v: '';
    }

    async setReportValues (self) {
        if (!self.fields) return;
        for (let field of self.fields) {
            if (field.defValue) {
                self.current[field.name] = field.defValue;
            } else {
                self.current[field.name] = null;
            }
        }
        if (self.serverClassName) {
            let fieldRestrict = await api.get('/api/get_field_restrict/', {ReportName: self.serverClassName});
            if (fieldRestrict) {
                for (let field of self.fields) {
                    if (fieldRestrict[field.name]) {
                        field.disabled = true;
                        self.current[field.name] = fieldRestrict[field.name];
                    }
                }
            }
        }
        if (self.options) {
            for (let field of self.fields) {
                if (self.options[field.name]) {
                    let value = self.options[field.name];
                    if (typeof value === 'object' && field.editor == 'date') {
                        value = moment(new Date()).add(value.days, 'days').format('YYYY-MM-DD');
                    }
                    field.defValue = value;
                    self.current[field.name] = value;
                }
            }
        }
        let values = await api.get('/api/reportfilter/', {filters: JSON.stringify(
            {
                ComponentName: self.$options.name,
            }
        ), noRelations: true});

        if (values) {
            for (let filter of values) {
                if (filter.UserId && filter.UserId == api.currentUser.id) {
                    self.current[filter.FieldName] = filter.FieldValue;
                    if (filter.Disabled) {
                        let field = self.fields.find(f => f.name == filter.FieldName);  
                        if (field) field.disabled = true;
                    }
                }
            }
        }
        self.fields = Object.assign([], self.fields);
    }

    importJSON (name, path, module, dict) {
        let extras = Object.assign([], api.EXTRAS).reverse();
        let p = `@/${path}/${name}.json`;
        let m;
        if (!module && extras.length>0) {
            m  = extras[0];
            p = `@/extra/${m}/${path}/${name}`;
        } else if (extras.length>0) {
            let i = extras.indexOf(module);
            m = extras[i+1];
            if (m) p = `@/extra/${m}/${path}/${name}`;
        }
        let res;
        try {
            if (m) {
                res = require(`@/extra/${m}/${path}/${name}`);
            } else {
                res = require(`@/${path}/${name}`);
            }
        } catch (err) {
            if (m) res = this.importJSON(name, path, m);
        }
        if (res && dict) res = Object.assign(res, dict);
        if (m) res = this.importJSON(name, path, m, res);
        return res;
    }

    getFlightsMail (body, booking, bookingForm) {
        body += '<br>';
        body += '<p>Vuelos</p>';
        for (let flight of booking.BookingFlights) {
            body += '<p>' + flight.Output + '</p>';
        }
        body += '<br>';
        if (customTools && customTools.getFlightsMail) body = customTools.getFlightsMail(body, booking, bookingForm);
        return body;
    }

    downloadReportCSV (id, fileName) {
        let table = $('#' + id);
        let csv = table.table2CSV({
            delivery: 'value'
        });
        this.download(fileName,  encodeURIComponent(csv))
    }

    exportToPDF (id, fileName, columnStyles, tableWidth, format) {
        const doc = new jsPDF({
            orientation: 'landscape',
            format
        });
        doc.autoTable({
            html: '#' + id ,
            tableWidth,
            columnStyles,
            useCss: true,
            rowPageBreak: 'avoid'

        });
        doc.save(fileName);
    }


    downloadReport (id, fileName) {
        let table = document.getElementById(id);
        let worksheet = tools.normalizeText(table.innerHTML);
        this.download(fileName, escape(worksheet))
    }

    download (filename, text, format) {
        if (!format) format = 'plain';
        var element = document.createElement('a');
        element.setAttribute('href', `data:text/${format};charset=utf-8,` + text);
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    exportToExcel (id, fileName) {

        const table = document.getElementById(id);
        const ws = XLSX.utils.table_to_sheet(table, { cellHTML: true, cellStyles: true });

        let firstRow = table.rows[0]
        var wscols = [];
        var cols = [];
        for (let cell of firstRow.cells) {
            let style = getComputedStyle(cell);
            let cellId = cell.getAttribute('cellcode');
            let c = cellId.substring(0, 1);
            cols.push(c);
            let w = parseInt(style.width.replace('px', '')) / 8;
            wscols.push({wch:w})
        }

        for (let row of table.rows) {
            for (let cell of row.cells) {
                let style = getComputedStyle(cell);
                let cellId = cell.getAttribute('cellcode');
                if (ws[cellId]) {
                    ws[cellId].s = this.getCellStyle(style);
                    ws[cellId].v = cell.innerText;
                    ws[cellId].t = 's';
                    //delete ws[cellId].z;
                }
            }
        }
        let border = {
            style: 'thin',
            color: {rgb: 'DEE2E6'}
        }
        let borders = {
            top: border,
            bottom: border,
            left: border,
            right: border,
        }

        for (let i=1; i<table.rows.length+1; i++) {
            for (let c of cols) {
                let cellId = c + i;
                if (!ws[cellId]) {
                    ws[cellId] = {
                        t: 's',
                        v: '',
                        s: {
                            border: borders
                        }
                    }
                }
            }
        }
        ws['!cols'] = wscols;
        /*ws['!protect'] = {
          password: '12345',
          selectLockedCells: true,
          selectUnlockedCells: true,
          formatCells: true,
          formatColumns: true,
          formatRows: true,
          insertColumns: true,
          insertRows: true,
          insertHyperlinks: true,
          deleteColumns: true,
          deleteRows: true,
          sort: true,
          autoFilter: true,
          pivotTables: true,
          objects: true,
          scenarios: true,
        };*/
        const wb1 = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb1, ws, "report");
        XLSX.writeFile(wb1, fileName);

    }


    toHex (s) {
      if (s == "rgba(0, 0, 0, 0)") return 'FFFFFF';
      let t = s.replace('rgba', '').replace('(', '').replace(')', '').replace('#', '').replace('rgb', '');
      t = t.split(',');
      let r = parseInt(t[0]);
      let g = parseInt(t[1]);
      let b = parseInt(t[2]);
      let res = (1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1);
      return res.toUpperCase();
    }

    getCellStyle (style) {
        let res = {
            alignment: {},
            font: {},
        };
        let attrs = ['color', 'backgroundColor', 'textAlign', 'border', 'verticalAlign'];
        if (style.color) res.font.color = {rgb: this.toHex(style.color)};
        if (style.bold) res.font.bold = true;
        if (style.backgroundColor) {
            res.fill = {fgColor: {rgb: this.toHex(style.backgroundColor)}}
        };

        if (style.textAlign) res.alignment.horizontal = style.textAlign;
        if (style.verticalAlign == 'middle') res.alignment.vertical = 'center';
        let border = {
            style: 'thin',
            color: {rgb: 'DEE2E6'}
        }
        res.border = {
            top: border,
            bottom: border,
            left: border,
            right: border,
        }
        //return { font: { bold: true, color: { rgb: "FF0000" } } }
        return res;
    }

    getModuleByPath (path) {
        for (let moduleId in modules) {
            let f = _.find(modules[moduleId].endpoints, (r) => {
              if (r == path) return true;
              if (r.table && r.table == path && !r.path) return true;
              if (r.report && r.report == path) return true;
              if (r.path && r.path == path) return true;
              //return r == path || r.table == path || r.report == path || r.path == path
            });
            if (f) return modules[moduleId].label;
        }
    }

    routeAccess (t) {
        let access;
        if (t.path) return t.path;
        if (t.table) return t.table;
        if (t.report) return t.report;
        return t;
    }


    findModule (endpoint) {
      for (let key in modules) {
        let values = _.filter(modules[key].endpoints, (r) => {
          if (r.name && r.name == endpoint.name && !endpoint.report) return true;
          if (r.report && r.report == endpoint.name && endpoint.report) return true;
          if (endpoint.table && endpoint.table == r) return true;
          return r == endpoint
        });
        if (values.length > 0) {
          return values;
        }
      }
    }

    getMatchedPath (route) {
        if (route.name == 'report') return route.path.replace('/report', '');
        if (!route.params) return route.replace('/abm', '').replace('/report', '');
        let path = route.matched[0].path;
        for (let param in route.params) {
            let p1 = `/:${param}?`;
            let p2 = `:${param}`;
            path = path.replace(p1, '')
            let isNumber;
            if (route.params[param]) {
                isNumber = !Number.isNaN(parseInt(route.params[param]));
            }
            if (isNumber) {
                path = path.replace(`/:${param}`, '');
            } else {
                path = path.replace(p2, route.params[param]);
            }
        }
        return path.replace('/abm', '').replace('/report', '');

    }

    findPos(obj) {
        var curtop = 0;
        if (obj.offsetParent) {
            do {
                curtop += obj.offsetTop;
            } while (obj = obj.offsetParent);
        return [curtop];
        }
    }

    scrollTo (id, d) {
        let el = document.getElementById(id);
        if (!el) return;
        let p =  this.findPos(el);
        if (d) p[0] += d;
        window.scroll(0, p);
    }

    merge (a, b) {
        let r = Object.assign({}, a);
        for (let lang in b) {
            if (!a[lang]) r[lang] = {}
            for (let key in b[lang]) {
                if (!a[lang] || !a[lang][key]) r[lang][key] = []
                for (let i of b[lang][key]) {
                    r[lang][key].push(i)
                }
            }
        }
        return r
    }

    setToIndexDB (data, table, key) {
        let nubbo = indexedDB.open("nubbo-app");
        nubbo.onsuccess = () => {
            var db = nubbo.result;
            var tx = db.transaction(table, "readwrite");
            var store = tx.objectStore(table);
            store.put({id: key, data: data});
            db.close();
        }

    }

    removeIndexDB () {
        var req = indexedDB.deleteDatabase("nubbo-app");
        req.onsuccess = () => {
            console.log("Deleted database successfully");
            frontTools.createIndexDB();
        };
        req.onerror = () => {
            console.log("database not deleted");
        };
    }

    createIndexDB () {
        let nubbo = indexedDB.open("nubbo-app");
        nubbo.onupgradeneeded = () => {
            let db = nubbo.result;
            db.createObjectStore("bookingBkp", {keyPath: "id"});
            db.close();
        };
    }
    //Failed to read the 'result' property from 'IDBRequest': The request has not finished

    dropTable() {
        var request = indexedDB.open("nubbo-app", 4);
        request.onsuccess = async ()  => {
            var db = request.result;
            console.log(31, db.version)
            db.close();
        }

        request.onupgradeneeded = (event) => {
          const db = request.result;
          db.deleteObjectStore("bookingBkp");
          db.close();
        };
    }

    getFromIndexDB (table, key, callback) {
        var nubbo = indexedDB.open("nubbo-app");
        nubbo.onsuccess = async ()  => {
            var db = nubbo.result;
            if (!db.objectStoreNames.contains(table)) {
                db.close();
                frontTools.removeIndexDB();
            } else {
                    let tx = db.transaction(table);
                    let store = tx.objectStore(table);
                    let request = store.get(key);
                    request.onsuccess = async () => {
                        let r;
                        if (request.result) {
                            r = request.result.data;
                        }
                        if (callback)  callback(r);
                    }
                    db.close();
            }
        }
    }

    printScreen (id, fileName, callback, noHash) {
        html2canvas(document.querySelector("#" + id)).then(async (canvas) => {
            let img = canvas.toDataURL("image/png");
            if (img) {
                let res = await api.savePrintScreen(img, fileName, null, noHash);
                if (res) {
                    callback(res)
                }
            }
        });
    }

    printScreenModal (id, callback) {
        html2canvas(document.querySelector("#" + id)).then(async (canvas) => {
            let img = canvas.toDataURL("image/png");
            if (img) {
                callback(img)
            }
        });
    }


// Función genérica para exportar tablas a Excel
    exportTableToExcel (tableSelector, filename) {
    // Cargar SheetJS dinámicamente
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js';
    script.onload = function() {
      try {
        const table = document.querySelector(tableSelector);
        if (!table) throw new Error('Tabla no encontrada');
  
        // Crear matriz de datos
        const dataMatrix = [];
        const spannedCells = [];
        const numericCells = []; // Rastrear celdas numéricas
  
        // Procesar cada fila
        const rows = table.querySelectorAll('tr');
        rows.forEach((row, rowIndex) => {
          const rowData = [];
          const cells = row.querySelectorAll('th, td');
          let colIndex = 0;
          
          if (!numericCells[rowIndex]) numericCells[rowIndex] = [];
  
          cells.forEach(cell => {
            // Saltar celdas que ya fueron procesadas por rowspan/colspan
            while (spannedCells[rowIndex] && spannedCells[rowIndex][colIndex]) {
              rowData.push(spannedCells[rowIndex][colIndex]);
              colIndex++;
            }
  
            // Obtener dimensiones de la celda
            const rowspan = parseInt(cell.getAttribute('rowspan')) || 1;
            const colspan = parseInt(cell.getAttribute('colspan')) || 1;
            let cellValue = cell.textContent.trim() || 
                          (cell.querySelector('input') ? cell.querySelector('input').value.trim() : '');
            
            // Detectar si es un número y guardar la referencia
            let isNumeric = false;
            
            // Verificamos el formato del número (podría tener punto como decimal o como separador de miles)
            const numStr = cellValue.replace(/\s/g, ''); // Eliminar espacios
            
            // Determinar si es un número y cómo está formateado
            if (/^-?\d+(\.\d+)?$/.test(numStr)) {
              // Formato con punto como decimal: 35.00
              isNumeric = true;
              numericCells[rowIndex][colIndex] = parseFloat(numStr);
            } else if (/^-?\d+(,\d+)?$/.test(numStr)) {
              // Formato con coma como decimal: 35,00
              isNumeric = true;
              numericCells[rowIndex][colIndex] = parseFloat(numStr.replace(',', '.'));
            } else if (/^-?\d{1,3}(\.\d{3})+(,\d+)?$/.test(numStr)) {
              // Formato con punto como separador de miles y coma como decimal: 1.234,56
              isNumeric = true;
              numericCells[rowIndex][colIndex] = parseFloat(numStr.replace(/\./g, '').replace(',', '.'));
            } else if (/^-?\d{1,3}(,\d{3})+(\.\d+)?$/.test(numStr)) {
              // Formato con coma como separador de miles y punto como decimal: 1,234.56
              isNumeric = true;
              numericCells[rowIndex][colIndex] = parseFloat(numStr.replace(/,/g, ''));
            }
            
            // Solo para debug
            if (isNumeric) {
              console.log(`Valor original: ${cellValue}, Valor numérico: ${numericCells[rowIndex][colIndex]}`);
            }
  
            // Almacenar valor principal (como texto por ahora)
            rowData.push(cellValue);
  
            // Manejar celdas combinadas
            if (rowspan > 1 || colspan > 1) {
              for (let r = 0; r < rowspan; r++) {
                for (let c = 0; c < colspan; c++) {
                  if (r === 0 && c === 0) continue; // Celda principal ya procesada
                  
                  const targetRow = rowIndex + r;
                  const targetCol = colIndex + c;
                  
                  // Inicializar matrices si es necesario
                  if (!spannedCells[targetRow]) {
                    spannedCells[targetRow] = [];
                  }
                  if (isNumeric && !numericCells[targetRow]) {
                    numericCells[targetRow] = [];
                    numericCells[targetRow][targetCol] = numericCells[rowIndex][colIndex];
                  }
                  
                  // Almacenar referencia al valor combinado
                  spannedCells[targetRow][targetCol] = cellValue;
                }
              }
            }
  
            colIndex += colspan;
          });
  
          dataMatrix.push(rowData);
        });
  
        // Crear libro de Excel
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(dataMatrix);
        
        // Modificar el tipo de celda para números
        for (let rowIndex = 0; rowIndex < dataMatrix.length; rowIndex++) {
          for (let colIndex = 0; colIndex < dataMatrix[rowIndex].length; colIndex++) {
            if (numericCells[rowIndex] && numericCells[rowIndex][colIndex] !== undefined) {
              // Obtener la referencia de celda en formato A1
              const cellRef = XLSX.utils.encode_cell({r: rowIndex, c: colIndex});
              
              // Establecer el valor numérico y el formato con coma decimal
              ws[cellRef] = {
                t: 'n', // Tipo numérico
                v: numericCells[rowIndex][colIndex], // Valor numérico
                z: '#,##0.00' // Formato con coma decimal
              };
            }
          }
        }
  
        // Ajustar anchos de columnas automáticamente
        const colWidths = dataMatrix[0].map((_, colIndex) => ({
          wch: Math.max(
            ...dataMatrix.map(row => 
              (row[colIndex] ? row[colIndex].toString().length : 0) + 2
            )
          )
        }));
        ws['!cols'] = colWidths;
  
        // Añadir hoja al libro
        XLSX.utils.book_append_sheet(wb, ws, "Datos");
  
        // Descargar archivo
        const finalFilename = filename || `tabla_exportada_${new Date().toISOString().slice(0,10)}.xlsx`;
        XLSX.writeFile(wb, finalFilename);
        
        console.log('Tabla exportada exitosamente');
      } catch (error) {
        console.error('Error al exportar la tabla:', error);
      }
    };
    document.head.appendChild(script);
  }
  
  exportTablesToExcel (tableSelectors, filename, sheetNames) {
    // Cargar SheetJS dinámicamente
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js';
    script.onload = function() {
      try {
        if (!Array.isArray(tableSelectors)) {
          throw new Error('El parámetro tableSelectors debe ser un array');
        }
        
        // Si no se proporcionan nombres de hojas, usar nombres predeterminados
        if (!sheetNames || !Array.isArray(sheetNames) || sheetNames.length < tableSelectors.length) {
          sheetNames = tableSelectors.map((_, index) => `Hoja${index + 1}`);
        }
        
        // Crear libro de Excel
        const wb = XLSX.utils.book_new();
        
        // Procesar cada tabla
        tableSelectors.forEach((selector, tableIndex) => {
          const table = document.querySelector(selector);
          if (!table) {
            console.warn(`Tabla no encontrada para el selector: ${selector}`);
            return; // Continuar con la siguiente tabla
          }
          
          // Crear matriz de datos
          const dataMatrix = [];
          const spannedCells = [];
          const numericCells = []; // Rastrear celdas numéricas
          
          // Procesar cada fila
          const rows = table.querySelectorAll('tr');
          rows.forEach((row, rowIndex) => {
            const rowData = [];
            const cells = row.querySelectorAll('th, td');
            let colIndex = 0;
            
            if (!numericCells[rowIndex]) numericCells[rowIndex] = [];
            
            cells.forEach(cell => {
              // Saltar celdas que ya fueron procesadas por rowspan/colspan
              while (spannedCells[rowIndex] && spannedCells[rowIndex][colIndex]) {
                rowData.push(spannedCells[rowIndex][colIndex]);
                colIndex++;
              }
              
              // Obtener dimensiones de la celda
              const rowspan = parseInt(cell.getAttribute('rowspan')) || 1;
              const colspan = parseInt(cell.getAttribute('colspan')) || 1;
              let cellValue = cell.textContent.trim() || 
                            (cell.querySelector('input') ? cell.querySelector('input').value.trim() : '');
              
              // Detectar si es un número y guardar la referencia
              let isNumeric = false;
              
              // Verificamos el formato del número (podría tener punto como decimal o como separador de miles)
              const numStr = cellValue.replace(/\s/g, ''); // Eliminar espacios
              
              // Determinar si es un número y cómo está formateado
              if (/^-?\d+(\.\d+)?$/.test(numStr)) {
                // Formato con punto como decimal: 35.00
                isNumeric = true;
                numericCells[rowIndex][colIndex] = parseFloat(numStr);
              } else if (/^-?\d+(,\d+)?$/.test(numStr)) {
                // Formato con coma como decimal: 35,00
                isNumeric = true;
                numericCells[rowIndex][colIndex] = parseFloat(numStr.replace(',', '.'));
              } else if (/^-?\d{1,3}(\.\d{3})+(,\d+)?$/.test(numStr)) {
                // Formato con punto como separador de miles y coma como decimal: 1.234,56
                isNumeric = true;
                numericCells[rowIndex][colIndex] = parseFloat(numStr.replace(/\./g, '').replace(',', '.'));
              } else if (/^-?\d{1,3}(,\d{3})+(\.\d+)?$/.test(numStr)) {
                // Formato con coma como separador de miles y punto como decimal: 1,234.56
                isNumeric = true;
                numericCells[rowIndex][colIndex] = parseFloat(numStr.replace(/,/g, ''));
              }
              
              // Almacenar valor principal (como texto por ahora)
              rowData.push(cellValue);
              
              // Manejar celdas combinadas
              if (rowspan > 1 || colspan > 1) {
                for (let r = 0; r < rowspan; r++) {
                  for (let c = 0; c < colspan; c++) {
                    if (r === 0 && c === 0) continue; // Celda principal ya procesada
                    
                    const targetRow = rowIndex + r;
                    const targetCol = colIndex + c;
                    
                    // Inicializar matrices si es necesario
                    if (!spannedCells[targetRow]) {
                      spannedCells[targetRow] = [];
                    }
                    if (isNumeric && !numericCells[targetRow]) {
                      numericCells[targetRow] = [];
                      numericCells[targetRow][targetCol] = numericCells[rowIndex][colIndex];
                    }
                    
                    // Almacenar referencia al valor combinado
                    spannedCells[targetRow][targetCol] = cellValue;
                  }
                }
              }
              
              colIndex += colspan;
            });
            
            dataMatrix.push(rowData);
          });
          
          // Crear hoja de trabajo
          const ws = XLSX.utils.aoa_to_sheet(dataMatrix);
          
          // Modificar el tipo de celda para números
          for (let rowIndex = 0; rowIndex < dataMatrix.length; rowIndex++) {
            for (let colIndex = 0; colIndex < dataMatrix[rowIndex].length; colIndex++) {
              if (numericCells[rowIndex] && numericCells[rowIndex][colIndex] !== undefined) {
                // Obtener la referencia de celda en formato A1
                const cellRef = XLSX.utils.encode_cell({r: rowIndex, c: colIndex});
                
                // Establecer el valor numérico y el formato con coma decimal
                ws[cellRef] = {
                  t: 'n', // Tipo numérico
                  v: numericCells[rowIndex][colIndex], // Valor numérico
                  z: '#,##0.00' // Formato con coma decimal
                };
              }
            }
          }
          
          // Ajustar anchos de columnas automáticamente
          const colWidths = dataMatrix[0] ? dataMatrix[0].map((_, colIndex) => ({
            wch: Math.max(
              ...dataMatrix.map(row => 
                (row[colIndex] ? row[colIndex].toString().length : 0) + 2
              )
            )
          })) : [];
          ws['!cols'] = colWidths;
          
          // Añadir hoja al libro
          XLSX.utils.book_append_sheet(wb, ws, sheetNames[tableIndex]);
        });
        
        // Si no se agregó ninguna hoja, agregar una hoja vacía
        if (wb.SheetNames.length === 0) {
          const ws = XLSX.utils.aoa_to_sheet([['No se encontraron tablas']]);
          XLSX.utils.book_append_sheet(wb, ws, 'Sin datos');
        }
        
        // Descargar archivo
        const finalFilename = filename || `tablas_exportadas_${new Date().toISOString().slice(0,10)}.xlsx`;
        XLSX.writeFile(wb, finalFilename);
        
        console.log('Tablas exportadas exitosamente');
      } catch (error) {
        console.error('Error al exportar las tablas:', error);
      }
    };
    document.head.appendChild(script);
  }
}

window.frontTools = new FrontTools();
